import { PosixDate, PosixDateTransformer } from "../time/posix-date.js";
export const BaseColumnSchemaPart = {
    id: {
        type: "uuid",
        primary: true,
    },
    createdAt: {
        type: "bigint",
        transformer: PosixDateTransformer,
    },
    updatedAt: {
        type: "bigint",
        transformer: PosixDateTransformer,
    },
    deletedAt: {
        type: "bigint",
        // deleteDate registra esta columna como la de soft-delete de TypeORM.
        // Sin el flag, withDeleted()/restore() rompen con
        // MissingDeleteDateColumnError. La columna física sigue siendo bigint
        // nullable. Para borrar usar softDeleteEntity() (abajo), NO
        // db.softDelete().
        deleteDate: true,
        nullable: true,
        transformer: PosixDateTransformer,
    },
};
/**
 * Soft-delete que escribe `deletedAt` vía db.update() para que el valor pase
 * por PosixDateTransformer y quede en epoch millis.
 *
 * NO usar db.softDelete(): genera `SET deletedAt = CURRENT_TIMESTAMP` sin
 * pasar por el transformer, y MySQL coerciona ese datetime a número
 * YYYYMMDDHHMMSS (ej. 20260609133941) en vez de epoch millis. El filtrado
 * implícito de TypeORM (deleteDate) sigue funcionando: escribe la misma
 * columna y solo importa null vs no-null.
 */
export async function softDeleteEntity(db, entity, where) {
    return db.update(entity, where, { deletedAt: new PosixDate() });
}
